export var RegionEnum;
(function (RegionEnum) {
    RegionEnum["None"] = "None";
    RegionEnum["Albania"] = "\u0410\u043B\u0431\u0430\u043D\u0438\u044F";
    RegionEnum["Andorra"] = "\u0410\u043D\u0434\u043E\u0440\u0440\u0430";
    RegionEnum["Austria"] = "\u0410\u0432\u0441\u0442\u0440\u0438\u044F";
    RegionEnum["Belarus"] = "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C";
    RegionEnum["Belgium"] = "\u0411\u0435\u043B\u044C\u0433\u0438\u044F";
    RegionEnum["BosniaAndHerzegovina"] = "\u0411\u043E\u0441\u043D\u0438\u044F \u0438 \u0413\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430";
    RegionEnum["Bulgaria"] = "\u0411\u043E\u043B\u0433\u0430\u0440\u0438\u044F";
    RegionEnum["Croatia"] = "\u0425\u043E\u0440\u0432\u0430\u0442\u0438\u044F";
    RegionEnum["Cyprus"] = "\u041A\u0438\u043F\u0440";
    RegionEnum["CzechRepublic"] = "\u0427\u0435\u0445\u0438\u044F";
    RegionEnum["Denmark"] = "\u0414\u0430\u043D\u0438\u044F";
    RegionEnum["Estonia"] = "\u042D\u0441\u0442\u043E\u043D\u0438\u044F";
    RegionEnum["Finland"] = "\u0424\u0438\u043D\u043B\u044F\u043D\u0434\u0438\u044F";
    RegionEnum["France"] = "\u0424\u0440\u0430\u043D\u0446\u0438\u044F";
    RegionEnum["Germany"] = "\u0413\u0435\u0440\u043C\u0430\u043D\u0438\u044F";
    RegionEnum["Greece"] = "\u0413\u0440\u0435\u0446\u0438\u044F";
    RegionEnum["Hungary"] = "\u0412\u0435\u043D\u0433\u0440\u0438\u044F";
    RegionEnum["Iceland"] = "\u0418\u0441\u043B\u0430\u043D\u0434\u0438\u044F";
    RegionEnum["Ireland"] = "\u0418\u0440\u043B\u0430\u043D\u0434\u0438\u044F";
    RegionEnum["Italy"] = "\u0418\u0442\u0430\u043B\u0438\u044F";
    RegionEnum["Latvia"] = "\u041B\u0430\u0442\u0432\u0438\u044F";
    RegionEnum["Lithuania"] = "\u041B\u0438\u0442\u0432\u0430";
    RegionEnum["Luxembourg"] = "\u041B\u044E\u043A\u0441\u0435\u043C\u0431\u0443\u0440\u0433";
    RegionEnum["Malta"] = "\u041C\u0430\u043B\u044C\u0442\u0430";
    RegionEnum["Moldova"] = "\u041C\u043E\u043B\u0434\u043E\u0432\u0430";
    RegionEnum["Monaco"] = "\u041C\u043E\u043D\u0430\u043A\u043E";
    RegionEnum["Montenegro"] = "\u0427\u0435\u0440\u043D\u043E\u0433\u043E\u0440\u0438\u044F";
    RegionEnum["Netherlands"] = "\u041D\u0438\u0434\u0435\u0440\u043B\u0430\u043D\u0434\u044B";
    RegionEnum["NorthMacedonia"] = "\u0421\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u044F";
    RegionEnum["Norway"] = "\u041D\u043E\u0440\u0432\u0435\u0433\u0438\u044F";
    RegionEnum["Poland"] = "\u041F\u043E\u043B\u044C\u0448\u0430";
    RegionEnum["Portugal"] = "\u041F\u043E\u0440\u0442\u0443\u0433\u0430\u043B\u0438\u044F";
    RegionEnum["Romania"] = "\u0420\u0443\u043C\u044B\u043D\u0438\u044F";
    RegionEnum["Russia"] = "\u0420\u043E\u0441\u0441\u0438\u044F";
    RegionEnum["SanMarino"] = "\u0421\u0430\u043D-\u041C\u0430\u0440\u0438\u043D\u043E";
    RegionEnum["Serbia"] = "\u0421\u0435\u0440\u0431\u0438\u044F";
    RegionEnum["Slovakia"] = "\u0421\u043B\u043E\u0432\u0430\u043A\u0438\u044F";
    RegionEnum["Slovenia"] = "\u0421\u043B\u043E\u0432\u0435\u043D\u0438\u044F";
    RegionEnum["Spain"] = "\u0418\u0441\u043F\u0430\u043D\u0438\u044F";
    RegionEnum["Sweden"] = "\u0428\u0432\u0435\u0446\u0438\u044F";
    RegionEnum["Switzerland"] = "\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0438\u044F";
    RegionEnum["Ukraine"] = "\u0423\u043A\u0440\u0430\u0438\u043D\u0430";
})(RegionEnum || (RegionEnum = {}));
export var PriorityEnum;
(function (PriorityEnum) {
    PriorityEnum["Low"] = "\u041D\u0438\u0437\u043A\u0438\u0439";
    PriorityEnum["Medium"] = "\u0421\u0440\u0435\u0434\u043D\u0438\u0439";
    PriorityEnum["High"] = "\u0412\u044B\u0441\u043E\u043A\u0438\u0439";
})(PriorityEnum || (PriorityEnum = {}));
export var MaterialOriginTypeEnum;
(function (MaterialOriginTypeEnum) {
    MaterialOriginTypeEnum["Generic"] = "\u041E\u0431\u0449\u0438\u0439";
    MaterialOriginTypeEnum["Manufacturer"] = "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C";
    MaterialOriginTypeEnum["UserDefinedProduct"] = "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0439 \u043F\u0440\u043E\u0434\u0443\u043A\u0442";
})(MaterialOriginTypeEnum || (MaterialOriginTypeEnum = {}));
